import React from "react";
import { inject, observer } from "mobx-react";
import { NnwClientModel } from "../../../../../helpers/nnwClient";
import { ProposalStore } from "../../../../../stores/proposalStore";
import ToggleButtonGroupCustom from "../../../../sharedComponents/toggleButtonGroup/toggleButtonGroup";
import { yesNo } from "../../../../../helpers/yesNo";
import Pesel from "../../../../sharedComponents/pesel/pesel";
import { TextField } from "@material-ui/core";
import Notification from "../../../../sharedComponents/notification/notification";
import Header from "../../../../sharedComponents/header/header";
import Formatter, { CapitalizationType } from "../../../../../helpers/formatter";
import { runInAction } from "mobx";

interface NnwClientBeneficiaryProps {
  proposalStore?: ProposalStore;
  client: NnwClientModel;
}

export function NnwClientBeneficiary(props: NnwClientBeneficiaryProps) {

  return (
    <div className="nnw-beneficiary">
      {renderBeneficiaryQuestion(props.client.beneficiaryChecked)}
      {props.client.beneficiaryChecked && renderBeneficiaryData()}
    </div>
  );

  function renderBeneficiaryData() {
    return (
      <div className="nnw-beneficiary-data">
        <Header type="small" mainHeader="Dane uposażonego do odbioru świadczenia" />
        {beneficiaryName()}
        <Pesel pesel={props.client.beneficiary.pesel} />
        {beneficiaryAddress()}
      </div>
    );
  }

  function beneficiaryName() {
    return (
      <div className="question-answer-container">
        <div className="question">Imię i Nazwisko</div>
        <TextField
          className={"text-input"}
          variant="outlined"
          size="small"
          onChange={(event) => {
            props.client.beneficiary.fullName.setValue(Formatter.capitalizeWords(event.target.value, CapitalizationType.full));
          }}
          onBlur={() => {
            props.client.beneficiary.fullName.setValue(props.client.beneficiary.fullName.value.trim());
            props.client.beneficiary.fullName.validate();
          }}
          value={props.client.beneficiary.fullName.value}
          error={!!props.client.beneficiary.fullName.errorMessage}
          helperText={getHelperText(props.client.beneficiary.fullName.errorMessage)}
          label="Imię i Nazwisko"
          InputLabelProps={{
            shrink: true
          }}
        />
      </div>);
  }

  function beneficiaryAddress() {
    return (
      <div className="question-answer-container">
        <div className="question">Adres zamieszkania</div>
        <TextField
          className={"text-input"}
          variant="outlined"
          size="small"
          onChange={(event) => {
            props.client.beneficiary.address.setValue(Formatter.capitalizeWords(event.target.value, CapitalizationType.full));
          }}
          onBlur={() => {
            props.client.beneficiary.address.setValue(props.client.beneficiary.address.value.trim());
            props.client.beneficiary.address.validate();
          }}
          value={props.client.beneficiary.address.value}
          error={!!props.client.beneficiary.address.errorMessage}
          helperText={getHelperText(props.client.beneficiary.address.errorMessage)}
          label="Adres zamieszkania"
          InputLabelProps={{
            shrink: true
          }}
        />
      </div>);
  }

  function renderBeneficiaryQuestion(value: boolean) {
    return (
      <ToggleButtonGroupCustom
        question="Czy chcesz wyznaczyć Uposażonego do odbioru świadczenia?"
        value={value ? yesNo.yes : yesNo.no}
        options={[{
          value: yesNo.yes,
          label: "TAK"
        }, {
          value: yesNo.no,
          label: "NIE"
        }]}
        onChange={(newValue) => {
          const newValueToBoolean = newValue === yesNo.yes;
          if (newValueToBoolean !== value) {
            runInAction(() => {
              // TODO: create setter and remove 'runInAction'
              props.client.beneficiaryChecked = newValueToBoolean;
            });
          }
        }}
      />
    );
  }

  function getHelperText(message: string | undefined) {
    return (!!message ? <Notification type="error" message={message} /> : "");
  }
}
export default inject("proposalStore")(observer(NnwClientBeneficiary));
